import React, { useEffect, useState } from 'react';
import '../App.css';
import logo from '../img/logo.png';
import { useNavigate } from 'react-router-dom';
import AuthModal from '../components/Modals/AuthModal';
import { useAuth } from '../contexts/AuthContext';

function Login() {
  const navigate = useNavigate();
  const [openAuth, setOpenAuth] = useState(false);

  const {
    currentUser,
    userProfile,
    userProfileLoading,
    isProfileComplete,
  } = useAuth();

  useEffect(() => {
    if (!currentUser) return;
    if (userProfileLoading) return;

    if (isProfileComplete(userProfile)) {
      navigate("/dashboard", { replace: true });
    }
  }, [currentUser, userProfile, userProfileLoading, isProfileComplete, navigate]);

  return (
    <div className='wrapper-container-login'>
      <div className='wrapper-login'>
        <div className='logo-container'>
          <img
            onClick={() => navigate(`/`)}
            className='logo-login'
            src={logo}
            alt="logo"
          />
        </div>

        <div className='header-login'>
          <h1 className='welcome'>Bienvenue</h1>
        </div>

        <div className='header-login'>
          <p className='text'>
            Connectez-vous à Fastline, pour acceder à votre espace client.
          </p>
        </div>

        <div className='button-container'>
          <button
            aria-label="Se connecter"
            className='google-button'
            onClick={() => setOpenAuth(true)}
          >
            <div className='google'></div>
            <p>Se connecter</p>
            <div className='google'></div>
          </button>
        </div>
      </div>

      {openAuth && (
        <AuthModal
          setIsOpen={setOpenAuth}
          onSuccess={() => navigate("/dashboard", { replace: true })}
        />
      )}
    </div>
  );
}

export default Login;